<template>
  <div class="module-container">
    <div class="title">证件信息</div>
    <ul class="infos">
      <li class="info-item">
        <div class="name">姓名</div>
        <div class="value">{{ infos.name }}</div>
      </li>
      <li class="info-item">
        <div class="name">性别</div>
        <div class="value">{{ formatSexText(infos.sex) }}</div>
      </li>
      <li class="info-item">
        <div class="name">登记类型</div>
        <div class="value">{{ formatTypeText(infos.type) }}</div>
      </li>
      <li class="info-item">
        <div class="name">配偶姓名</div>
        <div class="value">{{ infos.othername }}</div>
      </li>
      <li class="info-item">
        <div class="name">身份证</div>
        <div class="value">{{ infos.idCert }}</div>
      </li>
      <li class="info-item">
        <div class="name">登记日期</div>
        <div class="value">{{ infos.time }}</div>
      </li>
      <li class="info-item">
        <div class="name">登记机关</div>
        <div class="value">{{ formatDeptText(infos.dept) }}</div>
      </li>
      <li class="info-item">
        <div class="name">登记证号</div>
        <div class="value">{{ infos.certno }}</div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    infos: {
      type: Object,
      default: () => {
        return {
          name: '',
          sex: '',
          idcard: '',
          registerAt: '',
          registerOrg: '',
          registerCode: ''
        }
      }
    }
  },
  methods: {
    formatSexText(val) {
      const info = {
        1: '男',
        2: '女'
      }
      return info[val] ?? '-'
    },
    formatTypeText(val) {
      const info = {
        IA: '结婚',
        IB: '离婚'
      }
      return info[val] ?? '-'
    },
    formatDeptText(val) {
      const info = {
        320505: '虎丘区',
        320503: '姑苏区',
        320506: '吴中区',
        320584: '吴江区',
        320583: '昆山市',
        320582: '张家港市',
        320507: '相城区',
        320585: '太仓市',
        320581: '常熟市',
        320591: '工业园区'
      }
      return info[val] ?? '-'
    }
  }
}
</script>

<style lang="stylus" scoped>
.module-container {
  padding 30px
  font-family PingFangSC-Semibold, PingFang SC
  font-weight 400
  .title {
    height 53px
    font-size 38px
    font-weight 600
    color #333333
    line-height 53px
    padding-left 20px
    position relative
    z-index 5
    &::before {
      z-index -1
      position absolute
      content ''
      left 0
      top 50%
      transform translateY(-50%)
      width 36px
      height 36px
      border-radius 50%
      background linear-gradient(270deg, #DBEBFF 0%, #7DB7FF 100%)
    }
  }
  .infos {
    .info-item {
      display flex
      justify-content space-between
      align-items center
      padding 30px 0
      font-size 30px
      line-height 42px
      .name {
        width 210px
        margin-right 50px
        color #333333
      }
      .value {
        text-align right
        flex 1
        color #999999
      }
    }
    .info-item+.info-item {
      border-top 1px solid #ECECEC
    }
  }
}
</style>
